export default __webpack_public_path__ + "static/media/money-bag-with-a-shield.4abd8207.svg";